import { Input, Form, Flex } from "antd";
import "./Input.scss";
import CustomButton from "../CustomButton/Button";

const Password = Input?.Password || Input;

const isEmailField = (type, name) => {
  if (type === "email") return true;
  const fieldName = String(name || "").toLowerCase();
  return (
    fieldName === "email" ||
    fieldName.endsWith("email") ||
    fieldName.includes("email")
  );
};

const toLowerEmail = (value) =>
  typeof value === "string" ? value.toLowerCase() : value;

const CustomInput = ({
  label,
  name,
  rules,
  type,
  placeholder,
  addonBefore,
  isPassword,
  iconRender,
  onBlur,
  disabled,
  handleVerify,
  verifyBtn = false,
  isVerified = false,
  disableVerify,
  isTextArea,
  rows,
}) => {
  const shouldLowercaseEmail = isEmailField(type, name);

  const handleWheel = (e) => {
    if (type === "number") {
      e.currentTarget.blur();
    }
  };

  const handleEmailInput = (e) => {
    if (!shouldLowercaseEmail) return;
    e.target.value = e.target.value.toLowerCase();
  };

  return (
    <>
      {verifyBtn ? (
        <Form.Item
          label={label}
          name={name}
          rules={rules}
          normalize={shouldLowercaseEmail ? toLowerEmail : undefined}
          className="custom-input-form-item"
        >
          <Flex align="stretch" gap={8} className="verify-input-row">
            <Input
              className="custom-input"
              type={type}
              addonBefore={addonBefore}
              placeholder={placeholder}
              onBlur={onBlur}
              disabled={disabled}
              onWheel={handleWheel}
              onInput={handleEmailInput}
            />
            {verifyBtn && (
              <CustomButton
                className="verify-btn"
                loading={false}
                disabled={disableVerify}
                variant="solid"
                color="primary"
                style={{
                  backgroundColor: isVerified ? "#00874F" : undefined,
                  color: isVerified ? "#fff" : undefined,
                }}
                onClick={handleVerify}
              >
                {isVerified ? "Verified" : "Verify"}
              </CustomButton>
            )}
          </Flex>
        </Form.Item>
      ) : (
        <Form.Item
          label={label}
          name={name}
          rules={rules}
          normalize={shouldLowercaseEmail ? toLowerEmail : undefined}
          className="custom-input-form-item"
        >
          {isPassword ? (
            <Password
              className="custom-input"
              type={type}
              placeholder={placeholder}
              iconRender={iconRender}
            />
          ) : isTextArea ? (
            <Input.TextArea
              className="custom-input"
              rows={rows}
              type={type}
              placeholder={placeholder}
              onBlur={onBlur}
              disabled={disabled}
            />
          ) : (
            <Input
              className="custom-input"
              type={type}
              addonBefore={addonBefore}
              placeholder={placeholder}
              onBlur={onBlur}
              disabled={disabled}
              onWheel={handleWheel}
              onInput={handleEmailInput}
            />
          )}
        </Form.Item>
      )}
    </>
  );
};

export default CustomInput;
